


















































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import JdsIcon from '@/design-system/icons/JdsIcon.vue';
import { ActiveProvide } from '@/support/reactive';
import UniqueIdMixin from '@/design-system/utilities/UniqueIdMixin';
import throttle from '@/design-system/utilities/decorators/Throttle';

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 5.3.0 Move layout into meridian.
 * @changelog 5.3.0 Add flyout support
 * @changelog 5.11.0-rc.1 Add top slot for logo placement
 * @changelog 6.9.0 Add scrollbar tracking
 */
@Component({
    components: { JdsIcon }
})
export default class JdsMeridian extends Mixins(UniqueIdMixin) {
    /**
     * Set menu expanded
     */
    @Prop({ type: Boolean, default: false }) open!: boolean;
    @ActiveProvide('jds.meridian.open') provideOpen = false;
    @ActiveProvide('jds.meridian.uid') uid = '';
    @ActiveProvide('jds.meridian.scrollTop') scrollTop: number = 0;
    @ActiveProvide('jds.meridian.bus') meridianBus: Vue | null = null;

    navigatorCollapsed: boolean = true;

    mounted() {
        this.uid = this.$id();
        this.meridianBus = new Vue();
        this.meridianBus.$on('update', (state: boolean) => {
            this.navigatorCollapsed = state;
        });
    }

    @Watch('open', { immediate: true })
    updateProvideOpen(val: boolean) {
        this.provideOpen = val;
    }

    @throttle(300, { leading: false, trailing: true })
    onScrollTopUpdate(event: Event) {
        this.scrollTop = (event?.target as HTMLElement)?.scrollTop || 0;
    }
}
